const state = {
  dataDetail: {},
  keepAliveArr: [],
  //当前菜单
  currenMeunData: '',
  getRulesUser: {},
  //翻译组件接口传值
  queryTranData: [],
  // 翻译接口渲染的原始数据
  queryTranOrigin: [],
  //翻译查询的key
  queryTranKey: '',
  //翻译查询的国家Id
  queryTranCountryid: 0,
  loadingStatus:false,
  //语言版本
  languageStatus: localStorage.getItem("languageStatus") || 'zh',
  //查询leftFilter 数据
  leftFilter:{},
  //header 报告的名称
  reportName:"",
  //商业数据公司类型
  companyType:[],
  dynamicData:{},
  // 情报列表数量单位
  quantiyUnitsOptions: [],
  // 市场研究报告列表页筛选条件
  marketReportFilter: { keyword: "", industry: "", label: "", reportLanguage: "zh" },
  //总览切换tab的选中值
  dashboardSelectedTab:sessionStorage.getItem("dashboard_selected_tab_active") || "1"
}
const getters = {
  dataDetail: state => {
    return state.dataDetail
  },
  keepAliveArr: state => {
    return state.keepAliveArr
  },
  currenMeunData: state => {
    return state.currenMeunData
  },
  getGT6RulesUser: state => {
    return state.getRulesUser
  },
  queryTranData: state => {
    return state.queryTranData
  },
  queryTranOrigin: state => {
    return state.queryTranOrigin
  },
  queryTranKey: state => {
    return state.queryTranKey
  },
  queryTranCountryid: state => {
    return state.queryTranCountryid
  },
  loadingStatus: state => {
    return state.loadingStatus
  },
  languageStatus: state => {
    return state.languageStatus
  },
  leftFilter: state => {
    return state.leftFilter
  },
  reportName: state => {
    return state.reportName
  },
  companyType: state => {
    return state.companyType
  },
  dynamicGT6Data: state => {
    return state.dynamicData
  },
  // 数量单位
  quantiyUnitsOptions: state => {
    return state.quantiyUnitsOptions
  },
  //总览页切换tab保留值
  getDashboardSelectedTab: state=>{
    return state.dashboardSelectedTab
  },
  getMarketReportFilter: state => {
    return state.marketReportFilter
  }
}
const mutations = {
  set_data_detail: (state, data) => {
    state.dataDetail = data
  },
  set_keep_alive_arr: (state, data, type) => {//type===1：添加，2:删除
    let arr = state.keepAliveArr
    let index = arr.indexOf(data)
    if (index > -1 && type === 2) {
      arr.splice(index, 1)
    } else if (index < 0 && type === 1) {
      arr.push(data)
    }
    state.keepAliveArr = arr
  },
  curren_meun_data: (state, data) => {
    state.currenMeunData = data
  },
  get_rules_user: (state, data) => {
    state.getRulesUser = data
  },
  query_tran_data: (state, data) => {
    state.queryTranData = data
  },
  query_tran_origin: (state, data) => {
    state.queryTranOrigin = data
  },
  query_tran_key: (state, data) => {
    state.queryTranKey = data
  },
  query_tran_countryid: (state, data) => {
    state.queryTranCountryid = data
  },
  loading_status: (state, data) => {
    state.loadingStatus = data
  },
  language_status: (state, data) => {
    state.loadingStatus = data
  },
  left_filter: (state, data) => {
    state.leftFilter = data
  },
  report_name: (state, data) => {
    state.reportName = data
  },
  company_type: (state, data) => {
    state.companyType = data
  },
  dynamic_data: (state, data) => {
    state.dynamicData = data
  },
  // 数量单位
  quantiy_units_options: (state, data) => {
    state.quantiyUnitsOptions = data
  },
  set_dashboard_selected_tab(state, data) {
    state.dashboardSelectedTab = data
    sessionStorage.setItem("dashboard_selected_tab_active", data)
  },
  setMarketReportFilter: (state, data) => {
    state.marketReportFilter = data
  },
}
const actions = {
  chang_query_tran_data(context, data) {
    context.commit('query_tran_data', data)
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}